import { FileResponse, FolderResponse } from '@business/entities/file';
import mime from 'mime-types';

export function getSize(bytes: number, decimals = 2) {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

export function getExtensionFromMime(input: string) {
  return mime.extension(input);
}

export function getMimeFromExtension(filename: string) {
  return mime.lookup(filename);
}

export function getFileExtension(filename: string) {
  return filename.split('.').pop();
}

export function isImage(filename: string) {
  const ext = getFileExtension(filename);
  if (!ext) return false;
  return ['png', 'jpg', 'jpeg', 'bmp', 'gif'].includes(ext);
}

export function isPdf(filename: string) {
  const ext = getFileExtension(filename);
  if (!ext) return false;
  return ['pdf'].includes(ext);
}

export function isVideo(filename: string) {
  const ext = getFileExtension(filename);
  if (!ext) return false;
  return ['webm', 'avi', 'mov', 'wmv', 'mp4', 'm4p', 'm4v'].includes(ext);
}

export function getGoogleDocURL(filename: string) {
  return 'https://docs.google.com/viewer?url=' + filename + '&embedded=true';
}

export function isGoogleDocs(filename: string) {
  const ext = getFileExtension(filename);
  if (!ext) return false;
  return ['doc', 'docx', 'xlx', 'xlxs', 'pdf', 'ppt'].includes(ext);
}

export function getIcon(filename: string, item?: FileResponse | FolderResponse) {
  if (item && item.type === 'folder') {
    return 'bx bxs-folder text-primary';
  }
  const ext = getFileExtension(filename);
  if (item && item.fileType === 'document') {
    return 'bx bxs-file-doc text-warning';
  }
  if (item && item.fileType === 'form') {
    return 'bx bxs-book-content text-success';
  }
  if (!ext) return 'bx bxs-file text-dark';

  if (['png', 'jpg', 'jpeg', 'bmp', 'gif'].includes(ext)) {
    return 'bx bxs-image text-info';
  }
  if (isPdf(filename)) {
    return 'bx bxs-file-pdf text-dark';
  }

  if (isVideo(filename)) {
    return 'bx bxs-videos text-dark';
  }

  return 'bx bxs-file text-dark';
}
